import * as Highcharts from 'highcharts';
/* eslint-disable */
export const initializeHighcharts = function () {
  const H: any = Highcharts;
  H.wrap(H.seriesTypes.bar.prototype, 'translate', function (proceed) {
    let {
      topMargin,
      bottomMargin,
      borderRadiusTopLeft,
      borderRadiusTopRight,
      borderRadiusBottomRight,
      borderRadiusBottomLeft,
    } = this.options;
    topMargin = topMargin || 0;
    bottomMargin = bottomMargin || 0;
    proceed.call(this);
    this.points.forEach(function (point) {
      if (borderRadiusTopLeft || borderRadiusTopRight || borderRadiusBottomRight || borderRadiusBottomLeft) {
        const w = point.shapeArgs.width;
        const h = point.shapeArgs.height;
        const x = point.shapeArgs.x;
        const y = point.shapeArgs.y;
        let radiusTopLeft = H.relativeLength(borderRadiusTopLeft || 0, w);
        let radiusTopRight = H.relativeLength(borderRadiusTopRight || 0, w);
        let radiusBottomRight = H.relativeLength(borderRadiusBottomRight || 0, w);
        let radiusBottomLeft = H.relativeLength(borderRadiusBottomLeft || 0, w);
        const maxR = Math.min(w, h) / 2;
        radiusTopLeft = radiusTopLeft > maxR ? maxR : radiusTopLeft;
        radiusTopRight = radiusTopRight > maxR ? maxR : radiusTopRight;
        radiusBottomRight = radiusBottomRight > maxR ? maxR : radiusBottomRight;
        radiusBottomLeft = radiusBottomLeft > maxR ? maxR : radiusBottomLeft;
        point.dlBox = point.shapeArgs;
        point.shapeType = 'path';
        point.shapeArgs = {
          d: [
            'M',
            x + radiusTopLeft,
            y + topMargin,
            'L',
            x + w - radiusTopRight,
            y + topMargin,
            'C',
            x + w - radiusTopRight / 2,
            y,
            x + w,
            y + radiusTopRight / 2,
            x + w,
            y + radiusTopRight,
            'L',
            x + w,
            y + h - radiusBottomRight,
            'C',
            x + w,
            y + h - radiusBottomRight / 2,
            x + w - radiusBottomRight / 2,
            y + h,
            x + w - radiusBottomRight,
            y + h + bottomMargin,
            'L',
            x + radiusBottomLeft,
            y + h + bottomMargin,
            'C',
            x + radiusBottomLeft / 2,
            y + h,
            x,
            y + h - radiusBottomLeft / 2,
            x,
            y + h - radiusBottomLeft,
            'L',
            x,
            y + radiusTopLeft,
            'C',
            x,
            y + radiusTopLeft / 2,
            x + radiusTopLeft / 2,
            y,
            x + radiusTopLeft,
            y,
            'Z',
          ],
        };
      }
    });
  });
};
/* eslint-enable */
